import {
    getHeaders,
    getOptions,
    handleSessionExpiredError,
    handleFatalError,
    handleError,
} from './';
import { handleNoAccessError } from './error';
import forEach from 'lodash/forEach';
import { toastr } from 'react-redux-toastr';

export const get = path => {
    const headers = new Headers(getHeaders());
    const options = Object.assign({}, getOptions('GET'), { headers });

    return fetch(path, options).then(
        response => {
            const { status, statusText } = response;
            const json = response.json();
            if (status === 200 || status === 201 || status === 204) {
                return json;
            } else if (status === 401) {
                handleSessionExpiredError();
            } else if (status === 403) {
                handleNoAccessError();
            } else if (status >= 400 && status < 500) {
                return json.then(body => {
                    if (body.exceptions && body.exceptions.length > 0) {
                        console.error('GET errors', body.exceptions);
                        forEach(body.exceptions, e => {
                            handleError(e.message);
                        });
                    } else {
                        console.error('GET error', body.message);
                        handleError(body.message);
                    }
                });
            } else if (status >= 500) {
                handleFatalError(
                    status,
                    statusText,
                    'Something went wrong on the server side of this application...'
                );
            }
        },
        () => {
            handleError('Something went wrong... Is your network connection still active?');
        }
    );
};

export const del = (path , data)=> {
    const headers = new Headers(getHeaders());
    const body = data ? JSON.stringify(data) : null;
    const options = Object.assign({}, getOptions('DELETE'), { headers, body });

    return fetch(path, options).then(
        response => {
            const { status, statusText } = response;

            if (status === 200 || status === 201 || status === 204) {
                toastr.removeByType('error');
                return true;
            } else if (status === 401 || status === 404) {
                // 404 not found, for logging out unknown user
                // 401 for deleting while not logged in
                handleSessionExpiredError();
            } else if (status === 403) {
                handleNoAccessError();
            } else if (status >= 400 && status < 500) {
                handleError(`Something went wrong while deleting the data... (${status})`);
            } else if (status >= 500) {
                handleFatalError(
                    status,
                    statusText,
                    'Something went wrong on the server side of this application...'
                );
            }
        },
        () => {
            handleError('Something went wrong... Is your network connection still active?');
        }
    );
};

export const post = (path, data, isMultipart = false) => {
    let headers = null;
    let body = null;
    if (isMultipart) {
        headers = new Headers();
        body = data;
    } else {
        headers = new Headers(getHeaders());
        body = JSON.stringify(data);
    }
    const options = Object.assign({}, getOptions('POST'), { headers, body });

    return fetch(path, options).then(
        response => {
            const { status, statusText } = response;
            if (status === 204) {
                return response;
            }
            const json = response.json();
            if (status === 200 || status === 201) {
                toastr.removeByType('error');
                return json;
            } else if (status === 401) {
                handleSessionExpiredError();
            } else if (status === 403) {
                handleNoAccessError();
            } else if (status >= 400 && status < 500) {
                return json.then(body => {
                    if (body.exceptions && body.exceptions.length > 0) {
                        console.error('POST errors', body.exceptions);
                        forEach(body.exceptions, e => {
                            handleError(e.message);
                        });
                    } else {
                        console.error('POST error', body.message);
                        handleError(body.message);
                    }
                });
            } else if (status >= 500) {
                handleFatalError(
                    status,
                    statusText,
                    'Something went wrong on the server side of this application...'
                );
            }
        },
        () => handleError('Something went wrong... Is your network connection still active?')
    );
};

export default {
    get,
    post,
    del,
};
